import React from 'react';
import moment from 'moment';
import 'antd/dist/antd.css';
import { DatePicker, Space, Button } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import './customStyle.css';

const { RangePicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD';
// const dateFormat = 'MMM DD, YYYY';
const yesterday = moment().subtract(1, 'days');

class CustomDatepicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: "",
            endDate: "",
            className: 'margin-remove hide customDateStyle',
            openDatePicker: false,
            open: false,
            clickedCustom: false,
            activeNow: '',
            disableApply: true,
            customDatesString: ['', '']
        };
    }

    marginBottom = true;

    onClickBusinessDay = () => {
        this.marginBottom = true;
        this.setState({
            startDate: yesterday,
            endDate: yesterday,
            customDatesString: [yesterday, yesterday],
            className: this.marginBottom ? 'margin-remove hide customDateStyle' : 'hide customDateStyle',
            open: false,
            openDatePicker: false,
            activeNow: 'business_date'
        }, () => {
            this.props.onChangeData(
                [moment(this.state.startDate), moment(this.state.endDate)],
                [moment(this.state.startDate).format("YYYY-MM-DD"), moment(this.state.endDate).format("YYYY-MM-DD")])
        });
    };

    onClickSevenDays = () => {
        this.marginBottom = true;
        var startDate = moment().subtract(7, 'days');
        var endDate = moment(yesterday);
        this.setState({
            startDate: startDate,
            endDate: endDate,
            customDatesString: [startDate, endDate],
            className: this.marginBottom ? 'margin-remove hide customDateStyle' : 'hide customDateStyle',
            open: false,
            openDatePicker: false,
            activeNow: 'last_seven_days'
        }, () => {
            this.props.onChangeData(
                [moment(this.state.startDate), moment(this.state.endDate)],
                [moment(this.state.startDate).format("YYYY-MM-DD"), moment(this.state.endDate).format("YYYY-MM-DD")])
        });
    };

    onClickThirtyDays = () => {
        this.marginBottom = true;
        var startDate = moment().subtract(30, 'days');
        var endDate = moment(yesterday);
        this.setState({
            startDate: startDate,
            endDate: endDate,
            customDatesString: [startDate, endDate],
            className: this.marginBottom ? 'margin-remove hide customDateStyle' : 'hide customDateStyle',
            open: false,
            openDatePicker: false,
            activeNow: 'thirty_days'
        }, () => {
            this.props.onChangeData(
                [moment(this.state.startDate), moment(this.state.endDate)],
                [moment(this.state.startDate).format("YYYY-MM-DD"), moment(this.state.endDate).format("YYYY-MM-DD")])
        });
    };

    onClickThisMonth = () => {
        this.marginBottom = true;
        var startDate = moment().startOf('month');
        var endDate = moment(yesterday);
        this.setState({
            startDate: startDate,
            endDate: endDate,
            customDatesString: [startDate, endDate],
            className: this.marginBottom ? 'margin-remove hide customDateStyle' : 'hide customDateStyle',
            open: false,
            openDatePicker: false,
            activeNow: 'this_month'
        }, () => {
            this.props.onChangeData(
                [moment(this.state.startDate), moment(this.state.endDate)],
                [moment(this.state.startDate).format("YYYY-MM-DD"), moment(this.state.endDate).format("YYYY-MM-DD")])
        });
    };

    onClickLastMonth = () => {
        this.marginBottom = true;
        var startDate = moment().subtract(1, 'month').startOf('month');
        var endDate = moment().subtract(1, 'month').endOf('month');
        this.setState({
            startDate: startDate,
            endDate: endDate,
            customDatesString: [startDate, endDate],
            className: this.marginBottom ? 'margin-remove hide customDateStyle' : 'hide customDateStyle',
            open: false,
            openDatePicker: false,
            activeNow: 'last_month'
        }, () => {
            this.props.onChangeData(
                [moment(this.state.startDate), moment(this.state.endDate)],
                [moment(this.state.startDate).format("YYYY-MM-DD"), moment(this.state.endDate).format("YYYY-MM-DD")])
        });
    };

    onClickLastTwoMonths = () => {
        this.marginBottom = true;
        var startDate = moment().subtract(2, 'month').startOf('month');
        var endDate = moment().subtract(1, 'month').endOf('month');
        this.setState({
            startDate: startDate,
            endDate: endDate,
            customDatesString: [startDate, endDate],
            className: this.marginBottom ? 'margin-remove hide customDateStyle' : 'hide customDateStyle',
            open: false,
            openDatePicker: false,
            activeNow: 'last_two_month'
        }, () => {
            this.props.onChangeData(
                [moment(this.state.startDate), moment(this.state.endDate)],
                [moment(this.state.startDate).format("YYYY-MM-DD"), moment(this.state.endDate).format("YYYY-MM-DD")])
        });
    };

    onClickCustomRangeDay = () => {
        this.marginBottom = false;
        this.setState({
            className: this.marginBottom ? 'margin-remove show customDateStyle' : 'show customDateStyle',
            openDatePicker: true,
            open: true,
            activeNow: 'custom_range',
        });
    };

    onClickAddCustomRange = () => {
        let disableApplyBtn = true;
        if (this.state.startDate !== "" && this.state.endDate !== "") {
            disableApplyBtn = false;
        }
        this.setState({
            customDatesString: [this.state.startDate, this.state.endDate],
            open: false, openDatePicker: false, clickedCustom: true, disableApply: disableApplyBtn
        }, () => {
            this.props.onChangeData(
                [moment(this.state.startDate), moment(this.state.endDate)],
                [moment(this.state.startDate).format("YYYY-MM-DD"), moment(this.state.endDate).format("YYYY-MM-DD")])
        });
    }

    onClickCancel = () => {
        this.setState(prevState => ({
            startDate: this.state.customDatesString[0],
            endDate: this.state.customDatesString[1],
            open: false,
            openDatePicker: false,
            clickedCustom: true,
            activeNow: ''
        }), () => {
            // this.props.onChangeData(
            //     [moment(this.state.startDate), moment(this.state.endDate)],
            //     [moment(this.state.startDate).format("YYYY-MM-DD"), moment(this.state.endDate).format("YYYY-MM-DD")])
        });
    }

    handleInputChange = (e) => {
        if (!this.state.openDatePicker) { // if not custom range close and open dropdown
            if (this.state.clickedCustom && (this.state.activeNow === "custom_range" || this.state.activeNow == '') && !this.state.openDatePicker && !this.state.open) {
                // disable page click after custom range applied and then open again dropdown
                this.setState({ openDatePicker: true, clickedCustom: false, open: true })
            } else {
                this.setState({ open: e });
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // console.log(this.props.date, prevProps.date, "date")
        if (prevProps.date != this.props.date && this.props.date == null) {
            // console.log(this.props.date, prevProps.date, "date if");
            this.setState({ startDate: "", endDate: "" })
        } else if (this.props.date == "changed" && prevProps.date != this.props.date) {
            // console.log(this.props.date, prevProps.date, "date.....");
            this.setState({ startDate: "", endDate: "" })
        }
    }
    onChange = (e) => {
        if (e == null) {
            this.props.onChangeData(null, "");
        }
    }

    render() {
        return (
            <Space direction="vertical" size={12} style={{ width: '100%' }}>
                <RangePicker
                    Today={false}
                    style={{ width: '100%' }}
                    value={[
                        (this.state.startDate === "") ? "" : moment(this.state.startDate, dateFormat),
                        ((this.state.endDate === "") ? "" : moment(this.state.endDate, dateFormat))
                    ]}
                    className="dateRangeEnvelope"
                    suffixIcon={<DownOutlined />}
                    format={dateFormat}
                    dropdownClassName={this.state.className}
                    separator="-"
                    allowClear={true}
                    inputReadOnly={true}
                    open={this.state.open}
                    onOpenChange={this.handleInputChange}
                    disabledDate={d => !d || (yesterday != null && d.isAfter(yesterday, 'date'))}
                    onCalendarChange={(dates, datesString, info) => {
                        let disableApplyBtn = true;
                        if (datesString[0] !== "" && datesString[1] !== "") {
                            disableApplyBtn = false;
                        }
                        this.setState({
                            startDate: (datesString[0] != "") ? moment(datesString[0], dateFormat) : "",
                            endDate: (datesString[1] != "") ? moment(datesString[1], dateFormat) : "",
                            disableApply: disableApplyBtn
                        });
                    }}
                    onChange={this.onChange}
                    renderExtraFooter={() =>
                        <div>
                            <div className="picker-footer">
                                {/* <span>{[((this.state.startDate === "") ? "" : this.state.startDate.format("MM-DD-YYYY")) + ' - ' + ((this.state.endDate === "") ? "" : this.state.endDate.format("MM-DD-YYYY"))]}</span> */}
                                <Button type="button" onClick={this.onClickCancel}>Cancel</Button>
                                <Button type="primary" onClick={this.onClickAddCustomRange} disabled={this.state.disableApply}>Apply</Button>
                            </div>
                            <ul>
                                <li><div className={this.state.activeNow === 'business_date' ? 'active' : null} onClick={this.onClickBusinessDay}>Business Date</div></li>
                                <li><div className={this.state.activeNow === 'last_seven_days' ? 'active' : null} onClick={this.onClickSevenDays}>Last 7 Days</div></li>
                                <li><div className={this.state.activeNow === 'thirty_days' ? 'active' : null} onClick={this.onClickThirtyDays}>Last 30 Days</div></li>
                                <li><div className={this.state.activeNow === 'this_month' ? 'active' : null} onClick={this.onClickThisMonth}>This Month</div></li>
                                <li><div className={this.state.activeNow === 'last_month' ? 'active' : null} onClick={this.onClickLastMonth}>Last Month</div></li>
                                <li><div className={this.state.activeNow === 'last_two_month' ? 'active' : null} onClick={this.onClickLastTwoMonths}>Last 2 Months</div></li>
                                <li><div className={this.state.activeNow === 'custom_range' ? 'active' : null} onClick={this.onClickCustomRangeDay}>Custom Range</div></li>
                            </ul>
                        </div>
                    } />
            </Space>
        );
    }
}

export default CustomDatepicker;